export { default } from "./partnerInfoProvidingDialog";
